import React from "react";
import { Alert, Box, Checkbox, FormControlLabel, Link, Typography } from "@mui/material";

export const SMS_CONSENT_TEXT =
  "I agree to receive SMS messages from Micro Logic LLC and its products, including Plany365, Timely365, and AgentCrafty, regarding appointment reminders, booking confirmations, scheduling updates, service notifications, and customer support follow-up. Message frequency varies. Message and data rates may apply. Reply STOP to opt out and HELP for help. Consent is not a condition of purchase.";

export default function SmsConsentCheckbox({
  checked,
  onChange,
  error,
  sx = {},
  checkboxProps = {},
}) {
  return (
    <Box
      sx={{
        mt: 1,
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: error ? "error.main" : "divider",
        bgcolor: error ? "#fff5f5" : "background.paper",
        ...sx,
      }}
    >
      <FormControlLabel
        sx={{ alignItems: "flex-start", m: 0 }}
        control={
          <Checkbox
            required
            checked={!!checked}
            onChange={(event) => onChange?.(event.target.checked)}
            inputProps={{ "aria-label": "SMS consent", ...checkboxProps.inputProps }}
            {...checkboxProps}
          />
        }
        label={
          <Typography variant="body2" sx={{ lineHeight: 1.55 }}>
            {SMS_CONSENT_TEXT}
          </Typography>
        }
      />
      <Typography variant="caption" sx={{ display: "block", ml: { xs: 0, sm: 4 }, mt: 0.5 }}>
        <Link href="/privacy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </Link>
        {" | "}
        <Link href="/terms" target="_blank" rel="noopener noreferrer">
          Terms & Conditions
        </Link>
      </Typography>
      {error ? (
        <Alert severity="error" sx={{ mt: 1 }}>
          {error}
        </Alert>
      ) : null}
    </Box>
  );
}
